import { Box } from "@mui/material";
import FiberManualRecordIcon from "@mui/icons-material/FiberManualRecord";
import InfoIconTooltip from "./Icons/InfoIconTooltip";
import CustomIcon from "./CustomIcon";
import AppCache from "../Helper/Common/AppCache";
import { useBaseEntityInfo } from "../Hooks/usePagesContent";
import { PingStatusDefinitionRow } from "./PingStatus/PingStatusDefinition";
import {
  PING_STATUS_COLORS,
  getOfflineDefinition,
  getOnlineDefinition,
} from "./PingStatus/pingStatusDefinitions";

const getStatusRows = (entity, threshold) => [
  {
    label: "Online",
    description: getOnlineDefinition(entity, threshold),
    icon: <FiberManualRecordIcon sx={{ color: PING_STATUS_COLORS.online, width: 14, height: 14 }} />,
  },
  {
    label: "Charging",
    description: `Connected to a charger and battery is charging.`,
    icon: <CustomIcon name="charge-icon" sx={{ color: "#008A15", width: 14, height: 14 }} />,
    indent: true,
  },
  {
    label: "Discharging",
    description: `${entity} is in operation and consuming battery power.`,
    icon: <CustomIcon name="discharge-icon" sx={{ color: "#DCA101", width: 14, height: 14 }} />,
    indent: true,
  },
  {
    label: "Idle",
    description: `${entity} is powered on but not in operation; no active charging or significant discharge.`,
    icon: <CustomIcon name="pause-icon" sx={{ width: 14, height: 14 }} />,
    indent: true,
  },
  {
    label: "Offline",
    description: getOfflineDefinition(entity, threshold),
    icon: <FiberManualRecordIcon sx={{ color: PING_STATUS_COLORS.offline, width: 14, height: 14 }} />,
  },
];

const TooltipContent = () => {
  const { baseEntityTypeLable } = useBaseEntityInfo();
  const rows = getStatusRows(baseEntityTypeLable, AppCache.getItem("pingStatusThreshold"));

  return (
    <Box sx={{ display: "flex", flexDirection: "column", gap: "8px" }}>
      {rows.map(({ label, description, icon, indent }) => (
        <Box key={label} sx={{ pl: indent ? "16px" : 0 }}>
          <PingStatusDefinitionRow label={label} description={description} icon={icon} />
        </Box>
      ))}
    </Box>
  );
};

const VehicleStatusInfoTooltip = () => (
  <InfoIconTooltip title={<TooltipContent />} maxWidth={300} />
);

export default VehicleStatusInfoTooltip;
